
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.705 8.5a1.545 1.545 0 01-1.382-.854A2.072 2.072 0 0018.469 6.5c-1.385 0-2.506.717-3.213 2.484a4 4 0 01-3.714 2.516H6.25c-3.575 0-4.394-2.295-2.422-4.942a.5.5 0 00-.59-.762 4 4 0 00-.255 7.294A34.014 34.014 0 001.25 22a1.5 1.5 0 003 0v-.63a3.787 3.787 0 014-3.87h1.5c2.573 0 4.5 1.344 4.5 3.923V22a1.5 1.5 0 103 0c0-3.821-.134-2.13.613-6.984A2.967 2.967 0 0120.8 12.5a2.455 2.455 0 002.455-2.455 1.546 1.546 0 00-.454-1.094 1.545 1.545 0 00-1.096-.451v0zm-7.757 2.197L5.75.5m8.705 9.743l3.753 3.753m-.575 2.363l-5.016-5.016","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.25 9.25a.25.25 0 01.25.25m-.5 0a.25.25 0 01.25-.25m0 .5A.25.25 0 0118 9.5m.5 0a.25.25 0 01-.25.25","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    